import React from "react";

type ToggleItem = {
  id: string;
  name: string;
};
type BaseToggleButtonProp = {
  items: Array<ToggleItem>;
  setActiveTab: (item: ToggleItem) => void;
  activeTab: ToggleItem;
};

const BaseToggleButton: React.FC<BaseToggleButtonProp> = ({
  items,
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="flex items-center justify-center w-full">
      {items.map((item: ToggleItem) => (
        <button
          key={item?.name}
          onClick={() => setActiveTab(item)}
          className={`sm:mr-2 px-4 py-2 text-[1rem] font-[500] ${activeTab.id === item.id ? "bg-white rounded-[6px]" : "text-[#6B7381]"}`}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
};

export default BaseToggleButton;
